import React, { useEffect } from 'react';

const isTouchDevice = () => navigator.maxTouchPoints > 0;

export default function GeneratedPdfViewer({ url, title }) {
  useEffect(() => {
    return () => URL.revokeObjectURL(url);
  }, [url]);

  if (isTouchDevice()) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', gap: 16, padding: 24 }}>
        <span style={{ fontSize: 13, color: 'var(--text-muted)', textAlign: 'center' }}>{title}</span>
        <a
          href={url}
          target="_blank"
          rel="noreferrer"
          style={{ display: 'inline-block', padding: '10px 24px', background: 'var(--accent-light)', color: '#fff', borderRadius: 4, fontSize: 14, textDecoration: 'none', fontWeight: 500 }}
        >
          Open PDF
        </a>
      </div>
    );
  }

  return (
    <iframe
      src={`${url}#pagemode=none`}
      title={title || 'PDF'}
      style={{ width: '100%', height: '100%', border: 'none', display: 'block' }}
    />
  );
}
